<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="backList">活动列表</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>新增活动</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul class="cont_btns1">
        <li>
          <el-button
            @click="backList"
            type="primary"
          >返回活动列表</el-button>
        </li>
      </ul>
      <div class="contain_header1 clr">
        <el-steps :active="nextNum" style="width:850px;margin: 0 auto 30px">
          <el-step title="步骤 1"></el-step>
          <el-step title="步骤 2"></el-step>
          <el-step title="步骤 3"></el-step>
          <el-step v-if="form.acType == 1" title="步骤 4"></el-step>
        </el-steps>
        <el-form
          ref="form"
          :model="form"
          label-width="200px"
          :rules="addFormRule"
        >
          <el-form-item
            
            v-show="nextNum == 1"
            label="标题"
            prop='title'
          >
            <el-input
              style="width:400px"
              v-model="form.title"
              placeholder="请输入标题名称"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-show="nextNum == 1"
            label="列表图片"
            prop="listPic"
          >
            <el-upload
              class="avatar-uploader"
              action="/manager/user/seven_app_file_up"
              :show-file-list="false"
              :data='tokenData'
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img
                v-if="form.listPic"
                :src="form.listPic"
                class="avatar"
              >
              <i
                v-else
                class="el-icon-plus avatar-uploader-icon"
              ></i>
              <div
                slot="tip"
                class="el-upload__tip"
              >只能上传jpg/png文件，图片比例：365px × 165px</div>
            </el-upload>
          </el-form-item>

 <!--
          <el-form-item
            v-if="nextNum == 1"
            label="列表图片"
            prop="listPic"
          >
            <el-upload
              class="upload-demo"
              :multiple='true'
              action="/aj/manager/user/seven_app_file_up"
              :on-preview="handlePreview"
              :on-success="handleAvatarSuccess1"
              :on-remove="handleRemove"
              :data='tokenData'
              :file-list="form.listPic"
              list-type="picture"
            >
              <el-button
                size="small"
                type="primary"
              >点击上传</el-button>
              <div
                slot="tip"
                class="el-upload__tip"
              >只能上传jpg/png文件，图片比例：375px × 375px</div>
            </el-upload>
          </el-form-item>-->

          <el-form-item
            v-show="nextNum == 1"
            label="参加方式"
            prop="infoType"
          >
            <el-select
              @change="changeGoodType"
              v-model="form.infoType"
              placeholder="全部"
            >
              <el-option
                label="发货数量"
                :value='1'
              ></el-option>
              <el-option
                label="购进数量"
                :value="2"
              ></el-option>
              <el-option
                label="购进金额"
                :value="3"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            v-show="nextNum == 1"
            label="活动类型"
            prop="acType"
          >
            <el-select
              :disabled="form.id != null"
              v-model="form.acType"
              placeholder="全部"
            >
              <el-option
                label="阶梯活动"
                :value='1'
              ></el-option>
              <el-option
                label="指定商品活动"
                :value="2"
              ></el-option>
              
            </el-select>
          </el-form-item>

          <el-form-item
            label="限制代理等级"
            v-if="(form.infoType == 2 || form.infoType == 3) && nextNum == 1"
            prop="noBuyRoleTypes"
          >
            <el-select
              :multiple="true"
              v-model="form.noBuyRoleTypes"
              clearable
            >
              <el-option
                label="康减系列VIP会员"
                value="-0.5"
              ></el-option>
              <el-option
                label="康减系列高级会员"
                value="-0.4"
              ></el-option>
              <el-option
                label="康减系列荣誉会员"
                value="-0.3"
              ></el-option>
              <el-option
                label="康减系列市代"
                value="1.1"
              ></el-option>
              <el-option
                label="康减系列省代"
                value="2.1"
              ></el-option>
              <el-option
                label="康减系列CEO"
                value="3.1"
              ></el-option>
              <el-option
                label="VIP门店"
                value="0.0"
              ></el-option>
              <el-option
                label="联盟店"
                value="1.0"
              ></el-option>
              <el-option
                label="优秀联盟店"
                value="1.05"
              ></el-option>
              <el-option
                label="市代"
                value="2.0"
              ></el-option>
              <el-option
                label="省代"
                value="3.0"
              ></el-option>
              <el-option
                label="CEO"
                value="4.0"
              ></el-option>
              <el-option
                label="总经销商"
                value="5.0"
              ></el-option>
              <el-option
                label="合伙人"
                value="2.2"
              ></el-option>
              <el-option
                label="董事"
                value="4.2"
              ></el-option>
              <el-option label="经销商" value="4.8"></el-option>
              <el-option
                label="区域总监"
                value="5.1"
              ></el-option>
              <el-option
                label="城市加盟商"
                value="5.2"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            v-show="nextNum == 1"
            label="简介"
            prop='dection'
          >
            <el-input
            style="width:600px"
              type="textarea"
              :rows="2"
              v-model="form.dection"
              placeholder="请输入简介"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-show="nextNum == 1"
            label="开始时间"
            prop='startTime'
          >
            <el-date-picker
              v-model="form.startTime"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>

          <el-form-item
            v-show="nextNum == 1"
            label="结束时间"
            prop='endTime'
          >
            <el-date-picker
              v-model="form.endTime"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>

          <el-form-item
            v-show="nextNum == 1"
            label="有效期"
            prop='valideTime'
          >
            <el-date-picker
              v-model="form.valideTime"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>

          <el-form-item
            v-show="nextNum == 2"
            label="限制购买的商品"
            prop='needBuyGoodIds'
          >
            <div class="lanse" style="text-align: center;width: 680px">
              <div style="text-align: center;width: 680px">
                <el-transfer
                  style="text-align: left; display: inline-block"
                  v-model="form.needBuyGoodIds"
                  filterable
                  :left-default-checked="[2, 3]"
                  :right-default-checked="[1]"
                  :titles="['未选择', '已选择']"
                  :button-texts="['到左边', '到右边']"
                  :format="{
                  noChecked: '${total}',
                  hasChecked: '${checked}/${total}'
                }"
                  @change="handleChange"
                  :data="typeOptions">

                </el-transfer>
              </div>
            </div>
          </el-form-item>

          <el-form-item
            v-show="nextNum == 2 && form.acType == 1"
            label="活动优惠的商品"
            prop='goodIds'
          >
            <div class="lanse" style="text-align: center;width: 680px">
              <el-transfer
                style="text-align: left; display: inline-block"
                v-model="form.goodIds"
                filterable
                :left-default-checked="[2, 3]"
                :right-default-checked="[1]"
                :titles="['未选择', '已选择']"
                :button-texts="['到左边', '到右边']"
                :format="{
                  noChecked: '${total}',
                  hasChecked: '${checked}/${total}'
                }"
                @change="handleChange"
                :data="typeOptions">

              </el-transfer>
            </div>
          </el-form-item>

          <el-form-item
            v-show="nextNum == 3 && form.acType == 1"
            label="活动优惠的商品金额"
          >
            <el-table :data="form.goodIdsData">
              <el-table-column prop="id" label="序号" width='180'></el-table-column>
              <el-table-column prop="name" label="名称" width='180'></el-table-column>
              <el-table-column label="优惠金额">
                <template slot-scope="scope">
                  <el-form-item style="height: 60px" :prop="'goodIdsData.' + scope.$index + '.price'" :rules='addFormRule.price'>
                    <el-input style="width:200px" v-model="scope.row.price" type="number" @mousewheel.native.prevent @keyup.native="prevent($event)" placeholder="请输入金额"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>

          <el-form-item
            width="1000"
            v-show="nextNum == 3 && form.acType == 2"
            label="指定优惠的商品及金额"
          >
            <el-table :data="form.goodIdsData">
              <el-table-column prop="id" label="序号" width='220'></el-table-column>
              <el-table-column prop="name" label="名称" width='220'></el-table-column>
              <el-table-column label="购买数量" width='220'>
                <template slot-scope="scope">
                  <el-form-item style="height: 60px" :prop="'goodIdsData.' + scope.$index + '.buyNum'" :rules='addFormRule.buyNum'>
                    <el-input  style="width:200px" v-model="scope.row.buyNum" type="number" @mousewheel.native.prevent @keyup.native="prevent($event)" placeholder="请输入数量"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="指定特权商品" width='250'>
                <template slot-scope="scope">
                  <el-form-item style="height: 60px" :prop="'goodIdsData.' + scope.$index + '.buyGoodName'" :rules='addFormRule.buyGoodName'>
                    <el-input  style="width:200px" :disabled=true v-model="scope.row.buyGoodName" @mousewheel.native.prevent @keyup.native="prevent($event)" placeholder="请选择指定特权商品">
                      <el-button slot="append"  @click="showChooseGood(scope.$index)">选择</el-button>
                    </el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="优惠金额" width='220'>
                <template slot-scope="scope">
                  <el-form-item style="height: 60px" :prop="'goodIdsData.' + scope.$index + '.price'" :rules='addFormRule.price'>
                    <el-input  style="width:200px" v-model="scope.row.price" type="number" @mousewheel.native.prevent @keyup.native="prevent($event)" placeholder="请输入金额"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>


          <el-form-item
            v-if="nextNum == 4 && form.acType == 1"
            label="满足条件阶梯"
            prop='steps'
          >
            <div v-for="(item,index) in form.steps" :key="index">
              <div style="display: flex;align-items: center;justify-content: flex-start;margin-bottom: 20px">
                <div style="margin-right: 10px">满足数量:</div>
                <el-form-item
                  :prop="'steps.' + index + '.limitNum'"
                  :rules="addFormRule.steps"
                >
                  <el-input
                    style="width: 140px;margin-right: 30px"
                    type="number"
                    v-model="item.limitNum"
                    @mousewheel.native.prevent
                    @keyup.native="prevent($event)"
                    placeholder="请输入满足数量"
                  ></el-input>
                </el-form-item>
                <div style="margin-right: 10px">赠送数量:</div>
                <el-form-item
                  :prop="'steps.' + index + '.sendNum'"
                  :rules="addFormRule.steps"
                >
                  <el-input
                    style="width: 140px;margin-right: 30px"
                    type="number"
                    v-model="item.sendNum"
                    @mousewheel.native.prevent
                    @keyup.native="prevent($event)"
                    placeholder="请输入赠送数量"
                  ></el-input>
                </el-form-item>
                <el-button v-if="form.steps.length != 1" @click="clearSteps(index)">删除</el-button>
                <el-button v-if="form.steps.length == index + 1" @click="nextSteps()">新增</el-button>
              </div>
            </div>
          </el-form-item>

          <el-form-item>
            <el-button v-if="nextNum == 2" @click="next1">上一步</el-button>
            <el-button v-if="nextNum == 3" @click="next1">上一步</el-button>
            <el-button v-if="nextNum == 4" @click="next1">上一步</el-button>
            <el-button v-if="nextNum == 1" @click="next2">下一步</el-button>
            <el-button v-if="nextNum == 2" @click="next3">下一步</el-button>
            <el-button v-if="nextNum == 3 && form.acType == 1" @click="next4">下一步</el-button>
            <el-button
              v-if="nextNum == 4 || (nextNum == 3 && form.acType == 2)"
              type="primary"
              @click="onSubmit('form')"
              :loading="addLoading"
            >{{wordName}}</el-button>
          </el-form-item>
        </el-form>
      </div>

    </div>

    <el-dialog
      title="选择商品"
      :visible.sync="dialogAddVisible"
      width="40%"
    >

      <el-form
        label-position="top"
        class="m-search"
        ref="chooseGoodForm"
        size='small'
        :model="chooseGoodForm"
        :rules="chooseGoodFormRule"
      >

        <el-form-item
          label="选择商品"
          prop="buyGoodId"
        >
          <el-select
            v-model="chooseGoodForm.buyGoodId"
            placeholder="请选择" filterable
          >
            <el-option
              v-for="(option, index) in typeOptions"
              :value="index"
              :key='index'
              :label="option.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="addPost()"
            :loading="addLoading"
          >确定</el-button>
          <el-button @click="dialogAddVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </el-main>
</template>

<script>
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc.js";
var _ = require("lodash");
export default {
  name: "add_good",
  data() {
    return {
      chooseGoodForm:{
        buyGoodId:null,
        index:null
      },
      dialogAddVisible:false,
      filterMethod(query, item) {
        return item.pinyin.indexOf(query) > -1;
      },
      typeOptions: [],
      typeOptions1:[],
      tokenData: {
        token: localStorage.getItem("api_token")
      },
      options: [],
      good: null,
      wordName: "新增",
      props: {
        value: "id",
        label: "type_name"
      },
      chooseGoodFormRule: {
        buyGoodId: [
          {
            required: true,
            message: "请选择商品",
            trigger: "blur"
          }
        ],
      },
      addFormRule: {
        title: [
          {
            required: true,
            message: "请输入标题",
            trigger: "blur"
          }
        ],

        listPic: [
          {
            required: true,
            message: "请输入图片",
            trigger: "blur"
          }
        ],
        infoType: [
          {
            required: true,
            message: "请选择参加方式",
            trigger: "blur"
          }
        ],
        noBuyRoleTypes: [
          {
            required: true,
            message: "请选择限制代理等级",
            trigger: "blur"
          }
        ],
        needBuyGoodIds: [
          {
            required: true,
            message: "请选择限制购买的商品",
            trigger: "blur"
          }
        ],
        goodIds: [
          {
            required: true,
            message: "请选择活动优惠的商品",
            trigger: "blur"
          }
        ],
        activityGoodIds: [
          {
            required: true,
            message: "请选择活动优惠的商品",
            trigger: "blur"
          }
        ],
        price: [
          {
            required: true,
            message: "请输入金额",
            trigger: "blur"
          }
        ],
        buyNum: [
          {
            required: true,
            message: "请输入数量",
            trigger: "blur"
          }
        ],
        buyGoodName: [
          {
            required: true,
            message: "请选择指定特权商品",
            trigger: "blur"
          }
        ],
        dection: [
          {
            required: true,
            message: "请输入简介",
            trigger: "blur"
          }
        ],
        startTime: [
          {
            required: true,
            message: "请选择开始时间",
            trigger: "blur"
          }
        ],
        endTime: [
          {
            required: true,
            message: "请选择结束时间",
            trigger: "blur"
          }
        ],
        valideTime: [
          {
            required: true,
            message: "请选择有效期",
            trigger: "blur"
          }
        ],
        steps: [
          {
            required: true,
            message: "请输入满足条件阶梯",
            trigger: "blur"
          }
        ]
      },
      addLoading: false,
      fileList2: [],
      fileList3: [],
      fileList4: [],
      fileList5: [],
      nextNum: 1,
      form: {
        goodIdsData: [],
        acType:1,
        title: '',
        listPic: null,
        infoType: 1,
        noBuyRoleTypes: [],
        needBuyGoodIds: [],
        goodIds: [],
        activityGoodIds: [],
        dection: '',
        startTime: '',
        endTime: '',
        valideTime: '',
        steps: [{limitNum: null,sendNum: null}]
      },
      id: null
    };
  },
  mounted(e) {
    //初始化表单
    var that = this;
    this.page_num = 1;
    let params = {
      pageNum: 1,
      pageSize: 10000,
      token: localStorage.getItem("api_token")
    };
    that.loading = true;
    API.good_list(params)
      .then(
        function(result) {
          that.loading = false;
          if (result.key == 1000) {
            let typeOptions = []
            result.result.list.forEach(item => {
              typeOptions.push({
                label: item.good_name,
                key: item.id,
                pinyin: item.good_name,
                pic: item.list_pic
              })
            })
            that.typeOptions = typeOptions
          }
        },
        function(err) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: err.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error) {
        that.loading = false;
        that.$message.error({
          showClose: true,
          message: "请求出现异常",
          duration: 2000
        });
      });
    var activity = ''
    if (this.$route.query.activity) {
      activity = JSON.parse(this.$route.query.activity)
      this.id = activity.id;
    }
    console.log(activity)
    if (activity) {
      that.wordName = "修改";
      let needBuyGoodIds = []
      JSON.parse(activity.needGoodIds).forEach(item => {
        needBuyGoodIds.push(item.id)
      })
      let goodIds = []
      let goodIdsData = []
      if (activity.acType == 1){
        JSON.parse(activity.activityGoodIds).forEach(item => {
          goodIds.push(item.goodId)
          goodIdsData.push({
            id: item.goodId,
            name: item.name,
            price: item.price
          })
        })
      } else {
        JSON.parse(activity.needGoodIds).forEach(item => {
          goodIdsData.push({
            id: item.id,
            name: item.name,
            price: item.price,
            buyGoodId : item.buyGoodId,
            buyNum : item.buyNum,
            buyGoodName : item.buyGoodName,
            buyPic: item.buyPic
          })
        })
      }
      let noBuyRoleTypes = []
      if (activity.noBuyRoleTypes) {
        noBuyRoleTypes = activity.noBuyRoleTypes.split(",")
      }
      this.form = {
        title: activity.title,
        listPic: activity.listPic,
        acType:activity.acType,
        infoType: activity.infoType,
        noBuyRoleTypes: noBuyRoleTypes,
        needBuyGoodIds: needBuyGoodIds,
        goodIds: goodIds,
        activityGoodIds: [],
        dection: activity.desction,
        startTime: activity.startTime,
        endTime: activity.endTime,
        valideTime: activity.valideTime,
        goodIdsData: goodIdsData
      }
      if (activity.acType == 1){
        this.form.steps = JSON.parse(activity.steps)
      }
    } else {
      that.form.status = "1";
      that.wordName = "立即创建";
    }
  },
  computed: {},
  methods: {
    addPost(){
      
      let that = this;
      that.$refs["chooseGoodForm"].validate(valid => {
        if (valid) {
          console.log('数据：' + JSON.stringify(this.chooseGoodForm));
          this.form.goodIdsData[this.chooseGoodForm.index].buyGoodId = this.typeOptions[this.chooseGoodForm.buyGoodId].key;
          this.form.goodIdsData[this.chooseGoodForm.index].buyGoodName = this.typeOptions[this.chooseGoodForm.buyGoodId].label;
          this.form.goodIdsData[this.chooseGoodForm.index].buyPic = this.typeOptions[this.chooseGoodForm.buyGoodId].pic;
          this.dialogAddVisible = false;
        } else {

        }
      });
    },
    showChooseGood(index){
      this.chooseGoodForm.index = index;
      this.chooseGoodForm.buyGoodId = null;
      this.dialogAddVisible = true;
    },
    prevent (e){
      var keynum = window.event ? e.keyCode : e.which;   //获取键盘码
      // || keynum==190||keynum == 109 ||keynum == 110
      if (keynum ==189 ||keynum == 109) {
        this.$message.warning('禁止输入负数')
        e.target.value = ''
      }
    },
    nextSteps () {
      this.form.steps.push({limitNum: null,sendNum: null})
    },
    clearSteps (index) {
      if (this.form.steps.length == 1){
        this.$message.warning({
          showClose: true,
          message: "不能删除最后一条数据",
          duration: 1500
        });
        return
      }
      this.form.steps.splice(index,1);
    },
    next1 (e) {
      this.nextNum = this.nextNum * 1 - 1
    },
    next2 () {
      let fieldsToValidate
      if (this.form.infoType == 1) {
        fieldsToValidate = ['title','listPic','infoType','dection','startTime','endTime','valideTime'];
      } else {
        fieldsToValidate = ['title','listPic','infoType','noBuyRoleTypes','dection','startTime','endTime','valideTime'];
      }
      let that = this
      let goNext = true
      Promise.all(fieldsToValidate.map(item => {
        return new Promise(function (resolve, reject) {
          that.$refs.form.validateField(item, error => {
            resolve(error);
          })
        });
      })).then((data) => {
        console.log(data)
        //返回结果为data:['','','','',]全部为空，满足规则
        data.find(value=>{
          if(value!=""){
            goNext = false
          } else {
          }
        })
        if (goNext) {
          this.nextNum = 2
        } else {
          that.$message.error({
            showClose: true,
            message: "请检查是否有信息未填写",
            duration: 2000
          });
        }
      })
    },
    //选限制商品点击下一步
    next3 () {
      let fieldsToValidate;
      if (this.form.acType == 2)
      {
        fieldsToValidate = ['needBuyGoodIds'];
      } else {
        fieldsToValidate = ['needBuyGoodIds','goodIds'];
      }
      let that = this
      let goNext = true
      Promise.all(fieldsToValidate.map(item => {
        return new Promise(function (resolve, reject) {
          that.$refs.form.validateField(item, error => {
            resolve(error);
          })
        });
      })).then((data) => {
        console.log(data)
        //返回结果为data:['','','','',]全部为空，满足规则
        data.find(value=>{
          if(value!=""){
            goNext = false
          } else {
          }
        })
        if (goNext) {
          this.nextNum = 3
          let goodIdsData = []
          //阶梯活动
          if (this.form.acType == 1) {
            this.form.goodIds.forEach(item => {
              this.typeOptions.forEach(items => {
                if (item === items.key) {
                  goodIdsData.push({
                    id: items.key,
                    name: items.label,
                    price: null,
                    buyGoodId:-1,
                    buyNum:-1,
                    buyGoodName:-1,
                    buyPic: -1
                  })
                }
              })
            })
            this.form.goodIdsData.forEach(item => {
              goodIdsData.forEach(items => {
                if (item.id == items.id) {
                  items.price = item.price
                }
              })
            })
          } else {
            this.form.goodIds = [{id:1}];
            //指定特权活动
            this.form.needBuyGoodIds.forEach(item => {
              this.typeOptions.forEach(items => {
                if (item === items.key) {
                  goodIdsData.push({
                    id: items.key,
                    name: items.label,
                    price: null,
                    buyGoodId:null,
                    buyNum:null,
                    buyGoodName:null,
                    buyPic: null

                  })
                }
              })
            })
            this.form.goodIdsData.forEach(item => {
              goodIdsData.forEach(items => {
                if (item.id == items.id) {
                  items.price = item.price
                  items.buyGoodId = item.buyGoodId
                  items.buyNum = item.buyNum
                  items.buyGoodName = item.buyGoodName,
                  items.buyPic = item.buyPic
                }
              })
            })
          }
          this.form.goodIdsData = goodIdsData
        } else {
          that.$message.error({
            showClose: true,
            message: "请检查是否有信息未填写",
            duration: 2000
          });
        }
      })
    },
    //设置阶梯
    next4 () {
      let that = this
      if (this.form.acType == 1) {
        this.$refs.form.validate((valid) => {
        console.log(valid)
        if (!valid) {
          that.$message.error({
            showClose: true,
            message: "请检查是否有信息未填写",
            duration: 2000
          });
          return false
        } else {
          this.nextNum = 4
        }
      })
      } else {

      }
    },
    changeGoodType(e)
    {

      this.typeOptions1 = [];
      this.form.type_id = null;
      for (var i=0; i<this.typeOptions.length;i++)
      {
        if (this.typeOptions[i].noVip == this.form.no_vip)
        {
          this.typeOptions1.push(this.typeOptions[i]);
        }
      }
    },
    backList() {
      this.$router.back()
    },
    handleChange(value, direction, movedKeys) {
      console.log(this.form.activityGoodIds)
    },
    handleRemove(file, fileList) {
      // for (var i = 0; i < this.fileList2.length; i++) {
      //   if (this.fileList2[i].name == file.name) {
      //     this.fileList2.splice(i, 1);
      //     return;
      //   }
      // }

      var list = [];
      for (var i = 0; i < this.fileList4.length; i++) {
        if (this.fileList4[i].uid && this.fileList4[i].uid != null) {
          if (this.fileList4[i].uid != file.uid) {
            list.push(this.fileList4[i]);
          }
        } else {
          if (this.fileList4[i].name != file.name) {
            list.push(this.fileList4[i]);
          }
        }
      }
      this.fileList4 = list;
      if (this.fileList4.length == 0) {
        this.form.listPic = null;
      } else {
        this.form.listPic = JSON.stringify(this.fileList4);
      }
    },
    handleRemove1(file, fileList) {
      var list = [];
      for (var i = 0; i < this.fileList5.length; i++) {
        if (this.fileList5[i].uid && this.fileList5[i].uid != null) {
          if (this.fileList5[i].uid != file.uid) {
            list.push(this.fileList5[i]);
          }
        } else {
          if (this.fileList5[i].name != file.name) {
            list.push(this.fileList5[i]);
          }
        }
      }
      this.fileList5 = list;
      if (this.fileList5.length == 0) {
        this.form.detail_pic = null;
      } else {
        this.form.detail_pic = JSON.stringify(this.fileList5);
      }
    },
    handlePreview(file) {},
    handleAvatarSuccess1: function(e, file) {
      if (e.key == 1000) {
        this.fileList4.push({
          name: file.name,
          uid: file.uid,
          url: e.result.map.path,
          height: e.result.map.height,
          width: e.result.map.width
        });
        this.form.listPic = this.fileList4;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
        this.$refs.form.validateField("listPic");
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    handleAvatarSuccess2: function(e, file) {
      if (e.key == 1000) {
        this.fileList5.push({
          uid: file.uid,
          name: file.name,
          url: e.result.map.path,
          height: e.result.map.height,
          width: e.result.map.width
        });

        this.form.detail_pic = this.fileList5;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
        this.$refs.form.validateField("detail_pic");
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    handleAvatarSuccess: function(e) {
      if (e.key == 1000) {
        this.form.listPic = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    handleAvatarSuccessGive: function(e) {
      if (e.key == 1000) {
        this.form.give_pic = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    beforeAvatarUpload: function(e) {},
    onSubmit() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          let para = Object.assign({}, that.form);
          let form = {
            token: localStorage.getItem("api_token"),
            title: para.title,
            // titlePic: para.titlePic,
            listPic: para.listPic,
            infoType: para.infoType,
            activityGoodIds: [],
            acType:para.acType,
            dection: para.dection,
            
          }
          if (this.form.acType == 1)
          {
            form.steps = JSON.stringify(para.steps)
          }
          if (para.infoType != 1) {
            form.noBuyRoleTypes = para.noBuyRoleTypes.toString()
          } else {
            form.noBuyRoleTypes = ""
          }

          if (this.id != null) {
            form.id = this.id;
          }
          if (typeof(para.startTime) == 'number') {
            form.startTime = para.startTime;
          } else {
            form.startTime = para.startTime.getTime();
          }
          if (typeof(para.endTime) == 'number') {
            form.endTime = para.endTime;
          } else {
            para.endTime.setHours(23,59,59);
            form.endTime = para.endTime.getTime();
          }
          if (typeof(para.valideTime) == 'number') {
            form.valideTime = para.valideTime;
          } else {
            para.valideTime.setHours(23,59,59);
            form.valideTime = para.valideTime.getTime();
          }

          let needBuyGoodIds = [];//需要购买的商品
          if (this.form.acType == 2)
          {
            //指定特权活动
            this.form.goodIdsData.forEach(item => {
            this.typeOptions.forEach(items => {
              if (item.id === items.key) {
                needBuyGoodIds.push({
                    id: item.id,
                    name: item.name,
                    price: item.price,
                    buyGoodId:item.buyGoodId,
                    buyGoodName:item.buyGoodName,
                    buyNum:item.buyNum,
                    pic: items.pic,
                    buyPic:item.buyPic
                  })
                }
              })
            });
            form.needBuyGoodIds = JSON.stringify(needBuyGoodIds)
          } else {
            para.needBuyGoodIds.forEach(item => {
            this.typeOptions.forEach(items => {
              if (item === items.key) {
                needBuyGoodIds.push({
                  id: items.key,
                  name: items.label,
                  pic: items.pic
                })
              }
            })
          })
          form.needBuyGoodIds = JSON.stringify(needBuyGoodIds)
          let activityGoodIds = [];//活动优惠的商品
          this.form.goodIdsData.forEach(item => {
            this.typeOptions.forEach(items => {
              if (item.id === items.key) {
                activityGoodIds.push({
                  goodId: item.id,
                  name: item.name,
                  price: item.price,
                  pic: items.pic
                })
              }
            })
          })
          form.activityGoodIds = JSON.stringify(activityGoodIds)
          }
          that.addLoading = true;
          API.up_activity(form)
            .then(
              function(result) {
                that.addLoading = false;
                if (result.key == 1000) {
                  if (form.id) {
                    that.$message.success({
                      showClose: true,
                      message: "修改成功",
                      duration: 1500
                    });
                    that.$router.back()
                  } else {
                    that.$message.success({
                      showClose: true,
                      message: "创建成功",
                      duration: 1500
                    });
                    that.$router.back()
                  }
                  // resetForm();
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.loading = false;
                console.error(err);
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              console.error(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        } else {
          that.$message.error({
            showClose: true,
            message: "请检查是否有信息未填写",
            duration: 2000
          });
        }
      });
    },
    jumpTo(url) {
      this.defaultActiveIndex = url;
      this.$router.push(url); //用go刷新
    },
    resetForm() {
      let that = this;
      that.$refs["form"].resetFields();
    }
  }
};
</script>

<style>
.lanse .el-input__inner {
  border-color: #ced4da !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button{
  -webkit-appearance: none !important;
  margin: 0;
}
input[type="number"]{-moz-appearance:textfield;}
.area-select .area-selected-trigger {
  padding: 0px 20px 7px 12px;
  line-height: 40px;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}
.cont_btns1 {
  float: left;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns1 li {
  display: inline-block;
}
.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}

.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}

.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}

.contain_div {
  margin: 20px;
}

.contain_header1 {
  background-color: #fff;
  padding: 40px 0 20px 40px;
  /* margin-bottom: 20px; */
}

.area-select {
  height: 40px;
}

.area-select-wrap .area-select {
  margin-left: 0px !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/add_activityManagement.vue